import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getMarket_Group,
  getProdCategory,
  getProdList,
  getProduct_Family,
  getUOM,
  get_tool_grade,
  get_tool_sub_family,
  get_tool_type_family,
  gethsn_master,
  saveProduct,
  save_tool_fixture,
  updateProduct,
  update_tool_fixture,
} from "../../../../../api";
import {
  convertDateYYMMDD,
  getLabels,
} from "../../../../../common/Functions/CommonFunctions";
import { Accordion, Modal, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SweetAlert from "sweetalert2";
import DatePicker from "react-datepicker";

const schema = yup
  .object()
  .shape({
    tooltype: yup
      .array()
      .required("Please select consumable item type !")
      .min(1, "Please select consumable item type !"),
    toolsubtype: yup
      .array()
      .required("Please select consumable item sub-type !")
      .min(1, "Please select consumable item sub-type !"),
    // toolgrade: yup
    //   .array()
    //   .required("Please select consumable item grade !")
    //   .min(1, "Please select consumable item grade !"),
    productName: yup.string().required("Consumable item name is required !"),
    toolnumber: yup.string().required("Consumable item number is required !"),
    cal_freq: yup
      .string()
      .required("Calibration frequency is required !")
      .matches(/^[0-9]+$/, "Enter valid frequency !"),
    cal_validity: yup
      .string()
      .required("Calibration validity is required !")
      .matches(/^[0-9]+$/, "Enter valid validity !"),
    date: yup
      .date()
      .typeError("Please select calibration date !")
      .required("Please select a calibration date !"),
    duedate: yup
      .date()
      .typeError("Please select calibration due date !")
      .required("Please select a calibration due date !"),
    openingStock: yup
      .string()
      .transform((value, originalValue) =>
        originalValue.trim() === "" ? null : value
      )
      .matches(/^[0-9]+$/, "Enter valid opening stock")
      .nullable(),
    OEMnumber: yup
      .string()
      .nullable()
      .transform((value, originalValue) =>
        originalValue.trim() === "" ? null : value
      ),
    machineCost: yup
      .string()
      .required("Cost is required !")
      .matches(/^\d+(\.\d+)?$/, "Enter valid cost"),
    salesPrice: yup
      .string()
      .required("Sales price is required !")
      .matches(/^\d+(\.\d+)?$/, "Enter valid sales price"),
    purchase_price: yup
      .string()
      .required("Purchase price is required !")
      .matches(/^\d+(\.\d+)?$/, "Enter valid purchase price"),
    can_be_sold: yup.string().required("Required"),
  })
  .required();

function Tools(props) {
  let navigate = useNavigate();
  let location = useLocation();

  const [tooltype, settooltype] = useState({
    data: [],
    loading: false,
  });
  const [toolsubtype, settoolsubtype] = useState({
    data: [],
    loading: false,
  });
  const [toolgrade, settoolgrade] = useState({
    data: [],
    loading: false,
  });
  const [constLabel, setConstLabel] = useState({});
  const [btnDisable, setBtnDisable] = useState(false);
  const [calibrationDate, setcalibrationDate] = useState();
  const [calibrationDueDate, setcalibrationDueDate] = useState();
  const [tool_type, settool_type] = useState([]);
  const [tool_subtype, settool_subtype] = useState([]);
  const [toolsubdata, settoolsubdata] = useState({ data: [], loading: false });
  const [validity, setValidity] = useState();
  const [prodCategory, setProdCategory] = useState({data: [], loading: false});
  const [marketGroup, setMarketGroup] = useState({ data: [], loading: false });
  const [prodFamily, setProdFamily] = useState({ data: [], loading: false });
  const [uomList, setUOMList] = useState({ data: [], loading: false });
  const [hsnList, setHSNList] = useState({ data: [], loading: false });
  const [filterConfig, setFilterConfig] = useState({ hsn_sac_code: "" });
  const { register, handleSubmit, formState, control, reset, watch, setValue } =
    useForm({
      resolver: yupResolver(schema),
      mode: "onChange",
    }); // initialise the hook

  let { errors } = formState;

  useEffect(() => {
    setConstLabel(getLabels("Master", "Product"));
    fetchToolType_Family();
    fetchToolSubType();
    fetchToolGrade();
    fetchProductCategory();
    fetchMarketGroup();
    fetchProductFamily();
    fetchUOM();
    // console.log("main", props.main_obj);
    if (props?.main_obj?.prod_overview?.uuid) {
      let val =
        props.main_obj.prod_overview.toolfamily !== undefined &&
        props.main_obj.prod_overview.toolfamily !== null &&
        props.main_obj.prod_overview?.tool_family_id !== null
          ? [
              {
                uuid: props.main_obj.prod_overview.tool_family_id.uuid,
                name: props.main_obj.prod_overview?.tool_family_id.name,
                tool_family_code:
                  props.main_obj.prod_overview?.tool_family_id.tool_family_code,
              },
            ]
          : [];
      let val2 =
        props.main_obj.prod_overview.toolsubfamily !== undefined &&
        props.main_obj.prod_overview.toolsubfamily !== null &&
        props.main_obj.prod_overview?.tool_sub_family_id !== null
          ? [
              {
                uuid: props.main_obj.prod_overview.tool_sub_family_id.uuid,
                name: props.main_obj.prod_overview?.tool_sub_family_id.name,
                tool_sub_family_code:
                  props.main_obj.prod_overview?.tool_sub_family_id
                    .tool_sub_family_code,
              },
            ]
          : [];
      let val3 =
        props.main_obj.prod_overview.tool_grade_id !== undefined &&
        props.main_obj.prod_overview.tool_grade_id !== null &&
        props.main_obj.prod_overview?.tool_grade_id !== null
          ? [
              {
                uuid: props.main_obj.prod_overview.tool_grade_id.uuid,
                gradename:
                  props.main_obj.prod_overview?.tool_grade_id.gradename,
              },
            ]
          : [];
      setValue("tooltype", val);
      setValue("toolsubtype", val2);
      setValue("toolgrade", val3);
      settool_type(val);
      settool_subtype(val2);
      setcalibrationDate(
        new Date(props.main_obj.prod_overview.calibration_date)
      );
      setcalibrationDueDate(
        new Date(props.main_obj.prod_overview.calibration_duedate)
      );
      setValue(
        "date",
        new Date(props.main_obj.prod_overview.calibration_date),
        { shouldValidate: true }
      );
      setValue(
        "duedate",
        new Date(props.main_obj.prod_overview.calibration_duedate),
        { shouldValidate: true }
      );
      setValidity(props.main_obj.prod_overview.calibration_validity);
    }
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchHSN();
    }, 1000); // Adjust the delay as needed (e.g., 500 milliseconds)

    return () => {
      clearTimeout(debounceTimeout); // Clear the timeout if searchTerm changes before the timeout expires
    };
  }, [filterConfig]);

  function fetchHSN() {
    setHSNList({ ...hsnList, data: [], loading: true });
    let payload = {
      pageNo: 1,
      entriesPerPage: 1000,
    };
    if (
      filterConfig.hsn_sac_code !== "" &&
      filterConfig.hsn_sac_code.length >= 4
    ) {
      payload.hsn_sac_code = filterConfig.hsn_sac_code.trim(); // Search by hsn sac code
      gethsn_master(payload).then(
        (res) => {
          setHSNList({ ...hsnList, data: res.data.data, loading: false });
        },
        (err) => {
          setHSNList({ ...hsnList, data: [], loading: false });
        }
      );
    } else {
      // delete payload.hsn_sac_code;
      setHSNList({ ...hsnList, data: [], loading: false });
    }
  }

  function fetchUOM() {
    setUOMList({ ...uomList, data: [], loading: true });
    getUOM().then(
      (res) => {
        setUOMList({ ...uomList, data: res.data.data, loading: false });
      },
      (err) => {
        setUOMList({ ...uomList, data: [], loading: false });
      }
    );
  }

  function fetchProductCategory() {
    setProdCategory({ ...prodCategory, data: [], loading: true });
    getProdCategory().then(
      (res) => {
        setProdCategory({
          ...prodCategory,
          data: res.data.data,
          loading: false,
        });
      },
      (err) => {
        setProdCategory({ ...prodCategory, data: [], loading: false });
      }
    );
  }

  function fetchMarketGroup() {
    setMarketGroup({ ...marketGroup, data: [], loading: true });
    getMarket_Group().then(
      (res) => {
        setMarketGroup({
          ...marketGroup,
          data: res.data.data,
          loading: false,
        });
      },
      (err) => {
        setMarketGroup({ ...marketGroup, data: [], loading: false });
      }
    );
  }

  function fetchProductFamily() {
    setProdFamily({ ...prodFamily, data: [], loading: true });
    getProduct_Family().then(
      (res) => {
        setProdFamily({
          ...prodFamily,
          data: res.data.data,
          loading: false,
        });
      },
      (err) => {
        setProdFamily({ ...prodFamily, data: [], loading: false });
      }
    );
  }

  function fetchProdList(product_uuid) {
    getProdList({ uuid: product_uuid }).then(
      (res) => {
        props.setMain_obj({
          ...props.main_obj,
          prod_overview: res.data.data[0],
        });
        props.nextStep();
      },
      (err) => {}
    );
  }

  function filter_tool_sub_type(uuid) {
    settoolsubdata({ data: [], loading: true });
    let arr = toolsubtype.data.filter((item) => item.tool_family_id == uuid);
    settoolsubdata({ data: arr, loading: false });
  }
  const onSubmit = (data) => {
    setBtnDisable(true);

    if (data !== "") {
      const reqPayload = {
        productType: props.product_type?.prodTypeId,
        productTypename: props.product_type?.productType,
        product_type_id: props.product_type?.uuid,
        productName: data.productName,
        tool_family_id: data?.tooltype[0]?.uuid,
        toolfamily: data?.tooltype[0]?.name,
        tool_sub_family_id: data?.toolsubtype[0]?.uuid,
        toolsubfamily: data?.toolsubtype[0]?.name,
        tool_grade_id: data.toolgrade?.length > 0 ? data?.toolgrade?.[0]?.uuid : null,
        toolnumber: data?.toolnumber,
        calibration_frequency: data?.cal_freq,
        calibration_validity: data?.cal_validity,
        calibration_date: convertDateYYMMDD(calibrationDate, "-"),
        calibration_duedate: convertDateYYMMDD(calibrationDueDate, "-"),

        category: data.category.length
          ? data.category?.[0]?.categoryname
          : null,
        category_id: data.category.length ? data.category?.[0]?.uuid : null,
        marketgrp: data.marketGroup?.[0]?.grpId,
        market_grp_id: data.marketGroup?.[0]?.uuid,
        prodfamily: data.productFamily?.[0]?.familyId,
        prod_family_id: data.productFamily?.[0]?.uuid,
        openingstock: data.openingStock,
        hsn: data.hsn.length > 0 ? data.hsn?.[0]?.hsn_sac_code : null,
        hsn_uuid: data.hsn.length > 0 ? data.hsn?.[0]?.uuid : null,
        machineCost: data.machineCost,
        salesPrice: data.salesPrice,
        can_be_sold: data.can_be_sold,
        can_be_purchased: data.can_be_purchased,
        OEMnumber: data.OEMnumber,
        partNo: data.OEMnumber,
        purchase_price: data.purchase_price,
        unit_id: data.unit ? data.unit?.[0]?.uuid : "",
        remark: data.remark,
        batch_tracking: data.batch_tracking,
      };

      console.log("reqpayload", reqPayload);
      // console.log("validity",validity)

      // return

      // props.nextStep();
      if (props.main_obj.prod_overview?.uuid) {
        reqPayload.uuid = props.main_obj.prod_overview.uuid;

        // update_tool_fixture(reqPayload).then(
        updateProduct(reqPayload).then(
          (res) => {
            setBtnDisable(false);
            if (res.status === 200 || res.status === 201) {
              toast.success("Consumable item updated successfully !", {
                autoClose: 2000,
              });
              setTimeout(() => {
                // fetchProdList(res.data.uuid);
                fetchProdList(res.data.updatedRows?.[0]?.uuid);
              }, [2300]);
            }
          },
          (err) => {
            setBtnDisable(false);

            if (err.response.status === 400) {
              toast.error(err.response.data.message, {
                autoClose: 2000,
              });
            }
          }
        );
      } else {
        // save_tool_fixture(reqPayload).then(
        saveProduct(reqPayload).then(
          (res) => {
            console.log("res", res);
            setBtnDisable(false);

            if (res.status === 200 || res.status === 201) {
              toast.success("Consumable item created successfully !", {
                autoClose: 2000,
              });

              setTimeout(() => {
                // fetchProdList(res.data.uuid);
                fetchProdList(res.data.result.uuid);
              }, [2300]);
            }
          },
          (err) => {
            setBtnDisable(false);

            if (err.response.status === 400) {
              toast.error(err.response.data.message, {
                autoClose: 2000,
              });
            }
          }
        );
      }
    } else {
      errors.showMessages();
    }
  };

  function fetchToolType_Family() {
    settooltype({ loading: true, data: [] });

    get_tool_type_family().then(
      (res) => {
        settooltype({
          loading: false,
          data: res.data.data,
        });
      },
      (err) => {
        settooltype({ loading: false, data: [] });
      }
    );
  }
  function fetchToolSubType() {
    settoolsubtype({ loading: true, data: [] });

    get_tool_sub_family().then(
      (res) => {
        settoolsubtype({
          loading: false,
          data: res.data.data,
        });
        if (props?.main_obj?.prod_overview?.uuid) {
          let uuid = props.main_obj.prod_overview.tool_family_id.uuid;
          let arr = res.data.data.filter((item) => item.tool_family_id == uuid);
          settoolsubdata({ data: arr, loading: false });
        }
      },
      (err) => {
        settoolsubtype({ loading: false, data: [] });
      }
    );
  }

  function fetchToolGrade() {
    settoolgrade({ loading: true, data: [] });

    get_tool_grade().then(
      (res) => {
        settoolgrade({
          loading: false,
          data: res.data.data,
        });
      },
      (err) => {
        settoolgrade({ loading: false, data: [] });
      }
    );
  }

  return (
    <React.Fragment>
      <ToastContainer />

      <div className="card shadow-sm rounded-0 p-2">
        <div className="card-body">
          <p className="pc_card_title roboto-bold">
            {constLabel?.lbl_tool_summary
              ? constLabel?.lbl_tool_summary
              : "Consumable Item Summary"}
          </p>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_type
                    ? constLabel?.lbl_tool_type
                    : "Tool Type"}
                  <span className="text-danger">*</span>
                </label>
                <Controller
                  name="tooltype"
                  control={control}
                  // defaultValue={
                  //   props.main_obj.prod_overview.toolfamily !== undefined &&
                  //     props.main_obj.prod_overview.toolfamily !== null &&
                  //     props.main_obj.prod_overview?.tool_family_id !== null
                  //     ? [{uuid:props.main_obj.prod_overview.tool_family_id.uuid, name:props.main_obj.prod_overview?.tool_family_id.name }]
                  //     : []
                  // }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="name"
                      className="mt-2"
                      multiple={false}
                      options={tooltype.data}
                      isLoading={tooltype.loading}
                      placeholder="Select consumable item type"
                      onChange={(selected) => {
                        onChange(selected);

                        settool_type(selected);
                        //  console.log("selec",selected)
                        setValue("toolsubtype", []);
                        settool_subtype([]);
                        filter_tool_sub_type(selected[0]?.uuid);
                      }}
                      // defaultSelected={
                      //   props.main_obj.prod_overview.toolfamily !== undefined &&
                      //     props.main_obj.prod_overview.toolfamily !== null &&
                      //     props.main_obj.prod_overview?.tool_family_id !== null
                      //     ? [{uuid:props.main_obj.prod_overview.tool_family_id.uuid, name:props.main_obj.prod_overview?.tool_family_id.name }]
                      //     : []
                      // }
                      selected={value}
                      onBlur={onBlur}
                      isInvalid={errors.tooltype ? true : false}
                    />
                  )}
                />

                {errors.tooltype && (
                  <span className="text-danger err-msg">
                    {errors.tooltype.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_type_code
                    ? constLabel?.lbl_tool_type_code
                    : "Tool Type Code"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  className={"form-control mt-2"}
                  type="text"
                  placeholder="Enter consumable item type code"
                  defaultValue={
                    tool_type.length > 0 && tool_type[0]?.tool_family_code
                      ? tool_type[0]?.tool_family_code
                      : ""
                  }
                  disabled={true}
                  name="tooltypecode"
                />
              </div>
            </div>
            <div className="col-md-3 ">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_sub_type
                    ? constLabel?.lbl_tool_sub_type
                    : "Tool Sub-Type"}
                  <span className="text-danger">*</span>
                </label>
                <Controller
                  name="toolsubtype"
                  control={control}
                  // defaultValue={
                  //   props.main_obj.prod_overview.toolfamily !== undefined &&
                  //     props.main_obj.prod_overview.toolfamily !== null &&
                  //     props.main_obj.prod_overview.tool_family_uuid !== null
                  //     ? [props.main_obj.prod_overview?.tool_family_uuid]
                  //     : []
                  // }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="name"
                      className="mt-2"
                      multiple={false}
                      options={toolsubdata.data}
                      isLoading={toolsubdata.loading}
                      placeholder="Select consumable item sub-type"
                      onChange={(selected) => {
                        onChange(selected);
                        settool_subtype(selected);
                      }}
                      // defaultValue={
                      //   props.main_obj.prod_overview.category !== undefined &&
                      //     props.main_obj.prod_overview.category !== null &&
                      //     props.main_obj.prod_overview.category_id !== null
                      //     ? [props.main_obj.prod_overview?.category_id]
                      //     : []
                      // }
                      selected={value}
                      onBlur={onBlur}
                      isInvalid={errors.toolsubtype ? true : false}
                    />
                  )}
                />

                {errors.toolsubtype && (
                  <span className="text-danger err-msg">
                    {errors.toolsubtype.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-3 ">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_sub_type_code
                    ? constLabel?.lbl_tool_sub_type_code
                    : "Tool Sub Type Code"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  className={"form-control mt-2"}
                  type="text"
                  placeholder="Enter consumable item sub-type code"
                  defaultValue={
                    tool_subtype.length > 0 &&
                    tool_subtype[0]?.tool_sub_family_code
                      ? tool_subtype[0]?.tool_sub_family_code
                      : ""
                  }
                  disabled={true}
                  name="toolsubtypecode"
                  
                />
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_grade
                    ? constLabel?.lbl_tool_grade
                    : "Tool Grade"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <Controller
                  name="toolgrade"
                  control={control}
                  // defaultValue={
                  //   props.main_obj.prod_overview.toolfamily !== undefined &&
                  //     props.main_obj.prod_overview.toolfamily !== null &&
                  //     props.main_obj.prod_overview.tool_family_uuid !== null
                  //     ? [props.main_obj.prod_overview?.tool_family_uuid]
                  //     : []
                  // }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="gradename"
                      className="mt-2"
                      multiple={false}
                      options={toolgrade.data}
                      isLoading={toolgrade.loading}
                      placeholder="Select consumable item grade"
                      onChange={onChange}
                      // defaultValue={
                      //   props.main_obj.prod_overview.category !== undefined &&
                      //     props.main_obj.prod_overview.category !== null &&
                      //     props.main_obj.prod_overview.category_id !== null
                      //     ? [props.main_obj.prod_overview?.category_id]
                      //     : []
                      // }
                      selected={value}
                      onBlur={onBlur}
                      // isInvalid={errors.category ? true : false}
                    />
                  )}
                />

                {/* {errors.toolgrade && (
                  <span className="text-danger err-msg">
                    {errors.toolgrade.message}
                  </span>
                )} */}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_name
                    ? constLabel?.lbl_tool_name
                    : "Tool Name"}
                  <span className="text-danger">*</span>
                </label>
                <input
                  className={
                    errors.productName
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter consumable item name"
                  defaultValue={
                    props.main_obj.prod_overview.productName !== null &&
                    props.main_obj.prod_overview.productName !== ""
                      ? props.main_obj.prod_overview.productName
                      : ""
                  }
                  name="productName"
                  {...register("productName")}
                />
                {errors.productName && (
                  <span className="text-danger err-msg">
                    {errors.productName.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_tool_number
                    ? constLabel?.lbl_tool_number
                    : "Tool Number"}
                  <span className="text-danger">*</span>
                </label>
                <input
                  className={
                    errors.toolnumber
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter consumable item number"
                  defaultValue={
                    props.main_obj.prod_overview.toolnumber !== null &&
                    props.main_obj.prod_overview.toolnumber !== ""
                      ? props.main_obj.prod_overview.toolnumber
                      : ""
                  }
                  name="toolnumber"
                  {...register("toolnumber")}
                />
                {errors.toolnumber && (
                  <span className="text-danger err-msg">
                    {errors.toolnumber.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_calibration_frequency
                    ? constLabel?.lbl_calibration_frequency
                    : "Calibration Frequency"}
                  <span className="text-danger">*</span>
                </label>
                <input
                  className={
                    errors.cal_freq
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter calibration frequency"
                  defaultValue={
                    props.main_obj.prod_overview.calibration_frequency !==
                      null &&
                    props.main_obj.prod_overview.calibration_frequency !== ""
                      ? props.main_obj.prod_overview.calibration_frequency
                      : ""
                  }
                  name="cal_freq"
                  {...register("cal_freq")}
                />
                {errors.cal_freq && (
                  <span className="text-danger err-msg">
                    {errors.cal_freq.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_calibration_validity
                    ? constLabel?.lbl_calibration_validity
                    : "	Calibration Validity"}
                  <span className="text-danger">*</span>
                </label>
                <input
                  className={
                    errors.cal_validity
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter calibration validity"
                  value={validity}
                  defaultValue={
                    props.main_obj.prod_overview.calibration_validity !==
                      null &&
                    props.main_obj.prod_overview.calibration_validity !== ""
                      ? props.main_obj.prod_overview.calibration_validity
                      : ""
                  }
                  name="cal_validity"
                  {...register("cal_validity", {
                    onChange: (e) => {
                      console.log("e", e.target.value);
                      setValidity(e.target.value);
                      const inputValue = Number(e.target.value); // Convert the string to an integer
                      console.log("isNaN(inputValue)", isNaN(inputValue));

                      if (isNaN(inputValue) == false && calibrationDate) {
                        const dueDate = new Date(calibrationDate);
                        dueDate.setDate(
                          dueDate.getDate() + Number(e.target.value)
                        );
                        //  console.log("dueDate",dueDate);
                        setcalibrationDueDate(dueDate);
                        setValue("duedate", dueDate, { shouldValidate: true });
                      } else {
                        setcalibrationDueDate();
                      }
                    },
                  })}
                />
                {errors.cal_validity && (
                  <span className="text-danger err-msg">
                    {errors.cal_validity.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_calibration_date
                    ? constLabel?.lbl_calibration_date
                    : "Calibration Date"}
                  <span className="text-danger">*</span>
                </label>

                <Controller
                  control={control}
                  name="date"
                  render={({ field }) => (
                    <DatePicker
                      className={
                        errors.date
                          ? "form-control  is-invalid mt-2"
                          : "form-control mt-2 "
                      }
                      placeholderText="Select calibration date"
                      selected={calibrationDate}
                      onChange={(date) => {
                        field.onChange(date);

                        //  console.log("validity",validity);

                        if (date) {
                          setcalibrationDate(date);
                        } else {
                          setcalibrationDate();
                        }
                        if (validity && validity.length > 0 && date) {
                          const dueDate = new Date(date);
                          dueDate.setDate(dueDate.getDate() + Number(validity));
                          //  console.log("dueDate",dueDate);
                          setcalibrationDueDate(dueDate);
                          // setcalibrationDate(date);
                          setValue("duedate", dueDate, {
                            shouldValidate: true,
                          });
                        } else {
                          // setcalibrationDate()
                          setcalibrationDueDate();
                        }
                      }}
                      dateFormat="dd/MM/yyyy"
                      autoComplete="false"
                    />
                  )}
                />

                {errors.date && (
                  <span className="text-danger err-msg ">
                    {errors.date.message}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_calibration_due_date
                    ? constLabel?.lbl_calibration_due_date
                    : "Calibration Due Date"}
                  <span className="text-danger">*</span>
                </label>

                <Controller
                  control={control}
                  name="duedate"
                  render={({ field }) => (
                    <DatePicker
                      className={
                        errors.duedate
                          ? "form-control  is-invalid mt-2"
                          : "form-control mt-2  "
                      }
                      placeholderText="Select calibration due date"
                      selected={calibrationDueDate}
                      onChange={(date) => {
                        field.onChange(date);
                        setcalibrationDueDate(date);
                      }}
                      disabled={true}
                      // minDate={calibrationDate}
                      dateFormat="dd/MM/yyyy"
                      autoComplete="false"
                    />
                  )}
                />

                {errors.duedate && (
                  <span className="text-danger err-msg ">
                    {errors.duedate.message}
                  </span>
                )}
              </div>
            </div>
            
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_product_category
                    ? constLabel?.lbl_product_category
                    : "Product Category"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <Controller
                  name="category"
                  control={control}
                  defaultValue={
                    props.main_obj.prod_overview.category !== undefined &&
                    props.main_obj.prod_overview.category !== null &&
                    props.main_obj.prod_overview.category_id !== null
                      ? [props.main_obj.prod_overview?.category_id]
                      : []
                  }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="categoryname"
                      className="mt-2"
                      multiple={false}
                      options={prodCategory.data}
                      isLoading={prodCategory.loading}
                      placeholder="Select product category"
                      onChange={onChange}
                      defaultValue={
                        props.main_obj.prod_overview.category !== undefined &&
                        props.main_obj.prod_overview.category !== null &&
                        props.main_obj.prod_overview.category_id !== null
                          ? [props.main_obj.prod_overview?.category_id]
                          : []
                      }
                      selected={value}
                      onBlur={onBlur}
                      // isInvalid={errors.category ? true : false}
                    />
                  )}
                />

                {/* {errors.category && (
                  <span className="text-danger err-msg">
                    {errors.category.message}
                  </span>
                )} */}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_market_group
                    ? constLabel?.lbl_market_group
                    : "Market group"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <Controller
                  name="marketGroup"
                  control={control}
                  defaultValue={
                    props.main_obj.prod_overview.market_grp_id !== undefined &&
                    props.main_obj.prod_overview.market_grp_id !== null
                      ? [props.main_obj.prod_overview?.market_grp_id]
                      : []
                  }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="groupname"
                      className="mt-2"
                      multiple={false}
                      options={marketGroup.data}
                      isLoading={marketGroup.loading}
                      placeholder="Select market group"
                      onChange={onChange}
                      defaultSelected={
                        props.main_obj.prod_overview.market_grp_id !==
                          undefined &&
                        props.main_obj.prod_overview.market_grp_id !== null
                          ? [props.main_obj.prod_overview?.market_grp_id]
                          : []
                      }
                      selected={value}
                      onBlur={onBlur}
                      // isInvalid={errors.marketGroup ? true : false}
                    />
                  )}
                />

                {/* {errors.marketGroup && (
                  <span className="text-danger err-msg">
                    {errors.marketGroup.message}
                  </span>
                )} */}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_product_family
                    ? constLabel?.lbl_product_family
                    : "Product Family"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <Controller
                  name="productFamily"
                  control={control}
                  defaultValue={
                    props.main_obj.prod_overview.prod_family_id !== undefined &&
                    props.main_obj.prod_overview.prod_family_id !== null
                      ? [props.main_obj.prod_overview?.prod_family_id]
                      : []
                  }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="familyname"
                      className="mt-2"
                      multiple={false}
                      options={prodFamily.data}
                      isLoading={prodFamily.loading}
                      placeholder="Select product family"
                      onChange={onChange}
                      defaultSelected={
                        props.main_obj.prod_overview.prod_family_id !==
                          undefined &&
                        props.main_obj.prod_overview.prod_family_id !== null
                          ? [props.main_obj.prod_overview?.prod_family_id]
                          : []
                      }
                      selected={value}
                      onBlur={onBlur}
                      // isInvalid={errors.productFamily ? true : false}
                    />
                  )}
                />

                {/* {errors.productFamily && (
                  <span className="text-danger err-msg">
                    {errors.productFamily.message}
                  </span>
                )} */}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_opening_stock
                    ? constLabel?.lbl_opening_stock
                    : "Opening Stock"}
                </label>
                <input
                  className={
                    errors.openingStock
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  defaultValue={
                    props.main_obj.prod_overview.openingstock !== null &&
                    props.main_obj.prod_overview.openingstock !== ""
                      ? props.main_obj.prod_overview.openingstock
                      : 0
                  }
                  placeholder="Enter opening stock"
                  name="openingStock"
                  {...register("openingStock")}
                />
                {errors.openingStock && (
                  <span className="text-danger err-msg">
                    {errors.openingStock.message}
                  </span>
                )}
              </div>
            </div>

            {/* HSN select box */}
            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_hsn ? constLabel?.lbl_hsn : "HSN"}
                  {/* <span className="text-danger"> *</span> */}
                </label>
                <Controller
                  name="hsn"
                  control={control}
                  defaultValue={
                    props.main_obj.prod_overview.hsn_uuid !== undefined &&
                    props.main_obj.prod_overview.hsn_uuid !== null
                      ? [props.main_obj.prod_overview?.hsn_uuid]
                      : []
                  }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="hsn_sac_code"
                      className="mt-2"
                      multiple={false}
                      options={hsnList.data}
                      isLoading={hsnList.loading}
                      placeholder="Select hsn"
                      onChange={onChange}
                      defaultSelected={
                        props.main_obj.prod_overview.hsn_uuid !== undefined &&
                        props.main_obj.prod_overview.hsn_uuid !== null
                          ? [props.main_obj.prod_overview?.hsn_uuid]
                          : []
                      }
                      selected={value}
                      onBlur={onBlur}
                      // isInvalid={errors.hsn ? true : false}
                      onInputChange={(text) =>
                        setFilterConfig({ ...filterConfig, hsn_sac_code: text })
                      }
                    />
                  )}
                />
              </div>
            </div>
            {/* HSN select box */}

            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_unit ? constLabel?.lbl_unit : "Unit"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <Controller
                  name="unit"
                  control={control}
                  defaultValue={
                    props.main_obj.prod_overview.unit_id !== undefined &&
                    props.main_obj.prod_overview.unit_id !== null
                      ? [props.main_obj.prod_overview?.unit_id]
                      : []
                  }
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="uom"
                      className="mt-2"
                      multiple={false}
                      options={uomList.data}
                      isLoading={uomList.loading}
                      placeholder="Select unit"
                      onChange={onChange}
                      defaultSelected={
                        props.main_obj.prod_overview.unit_id !== undefined &&
                        props.main_obj.prod_overview.unit_id !== null
                          ? [props.main_obj.prod_overview?.unit_id]
                          : []
                      }
                      selected={value}
                      onBlur={onBlur}
                      // isInvalid={errors.unit ? true : false}
                    />
                  )}
                />

                {/* {errors.unit && (
                  <span className="text-danger err-msg">
                    {errors.unit.message}
                  </span>
                )} */}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="form-group mt-md-0 mt-3">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_oem_part_no
                    ? constLabel?.lbl_oem_part_no
                    : "OEM Part No"}
                </label>
                <input
                  className={
                    errors.OEMnumber
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter OEM part no"
                  name="OEMnumber"
                  defaultValue={
                    props.main_obj.prod_overview.OEMnumber !== null &&
                    props.main_obj.prod_overview.OEMnumber !== ""
                      ? props.main_obj.prod_overview.OEMnumber
                      : ""
                  }
                  {...register("OEMnumber")}
                />
                {errors.OEMnumber && (
                  <span className="text-danger err-msg">
                    {errors.OEMnumber.message}
                  </span>
                )}
              </div>
            </div>
          </div>

          <hr className="my-4" />
          <p className="pc_card_title roboto-bold">
            {constLabel?.lbl_product_detail
              ? constLabel?.lbl_product_detail
              : "Product Detail"}
          </p>
          <div className="row col-12">
            <div className="col-md-3 mt-3">
              <label className="lbl-style roboto-bold invisible">
                {constLabel?.lbl_can_be_sold
                  ? constLabel?.lbl_can_be_sold
                  : "Can be Sold"}
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked={
                    props.main_obj.prod_overview.can_be_sold
                      ? props.main_obj.prod_overview.can_be_sold
                      : false
                  }
                  name="can_be_sold"
                  {...register("can_be_sold")}
                />
                <label className="form-check-label lbl-style roboto-bold">
                  {constLabel?.lbl_can_be_sold
                    ? constLabel?.lbl_can_be_sold
                    : "Can be Sold"}
                </label>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <label className="lbl-style roboto-bold invisible">
                {constLabel?.lbl_can_be_pruchase
                  ? constLabel?.lbl_can_be_pruchase
                  : "Can be Purchase"}
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked={
                    props.main_obj.prod_overview.can_be_purchased
                      ? props.main_obj.prod_overview.can_be_purchased
                      : false
                  }
                  name="can_be_purchased"
                  {...register("can_be_purchased")}
                />
                <label className="form-check-label lbl-style roboto-bold">
                  {constLabel?.lbl_can_be_pruchase
                    ? constLabel?.lbl_can_be_pruchase
                    : "Can be Purchase"}
                </label>
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <label className="lbl-style roboto-bold invisible">
                {constLabel?.lbl_batch_tracking
                  ? constLabel?.lbl_batch_tracking
                  : "Batch Tracking"}
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked={
                    props.main_obj.prod_overview.batch_tracking
                      ? props.main_obj.prod_overview.batch_tracking
                      : false
                  }
                  name="batch_tracking"
                  {...register("batch_tracking")}
                />
                <label className="form-check-label lbl-style roboto-bold">
                  {constLabel?.lbl_batch_tracking
                    ? constLabel?.lbl_batch_tracking
                    : "Batch Tracking"}
                </label>
              </div>
            </div>
          </div>

          <hr className="my-4" />
          <p className="pc_card_title roboto-bold">
            {constLabel?.lbl_product_price
              ? constLabel?.lbl_product_price
              : "Product Price"}
          </p>
          <div className="row col-12">
            <div className="col-md-3">
              <div className="form-group">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_cost ? constLabel?.lbl_cost : "Cost"}
                  <span> &#8377;</span>
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  className={
                    errors.machineCost
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter cost"
                  name="machineCost"
                  defaultValue={
                    props.main_obj.prod_overview.machineCost !== null &&
                    props.main_obj.prod_overview.machineCost !== ""
                      ? props.main_obj.prod_overview.machineCost
                      : 0.0
                  }
                  {...register("machineCost")}
                />
                {errors.machineCost && (
                  <span className="text-danger err-msg">
                    {errors.machineCost.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_sales_price
                    ? constLabel?.lbl_sales_price
                    : "Sales Price "}
                  <span> &#8377;</span>
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  className={
                    errors.salesPrice
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter sales price"
                  name="salesPrice"
                  defaultValue={
                    props.main_obj.prod_overview.salesPrice !== null &&
                    props.main_obj.prod_overview.salesPrice !== ""
                      ? props.main_obj.prod_overview.salesPrice
                      : 0.0
                  }
                  {...register("salesPrice")}
                />
                {errors.salesPrice && (
                  <span className="text-danger err-msg">
                    {errors.salesPrice.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_purchase_price
                    ? constLabel?.lbl_purchase_price
                    : "Purchase Price "}
                  <span> &#8377;</span>
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  className={
                    errors.purchase_price
                      ? "form-control mt-2 is-invalid"
                      : "form-control mt-2"
                  }
                  type="text"
                  placeholder="Enter purchase price"
                  name="purchase_price"
                  defaultValue={
                    props.main_obj.prod_overview.purchase_price !== null &&
                    props.main_obj.prod_overview.purchase_price !== ""
                      ? props.main_obj.prod_overview.purchase_price
                      : 0.0
                  }
                  {...register("purchase_price")}
                />
                {errors.purchase_price && (
                  <span className="text-danger err-msg">
                    {errors.purchase_price.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <div className="form-group">
                <label className="lbl-style roboto-bold">
                  {constLabel?.lbl_remark ? constLabel?.lbl_remark : "Remark"}
                </label>
                <textarea
                  className="form-control mt-2"
                  id="remark"
                  type="text"
                  defaultValue={
                    props.main_obj.prod_overview.remark !== null &&
                    props.main_obj.prod_overview.remark !== ""
                      ? props.main_obj.prod_overview.remark
                      : ""
                  }
                  placeholder="Enter remark"
                  name="remark"
                  {...register("remark")}
                ></textarea>
              </div>
            </div>
          </div>
          <hr className="my-4" />

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-grey px-4 me-2"
              onClick={() => navigate("/pcms/product")}
            >
              {constLabel?.lbl_cancel ? constLabel?.lbl_cancel : "Cancel"}
            </button>
            <button
              className="btn button-primary px-4 me-2"
              onClick={handleSubmit(onSubmit)}
              disabled={btnDisable}
              // onClick={() => props.setCurrentStep(props.currentStep + 1)}
            >
              {constLabel?.lbl_save_continue
                ? constLabel?.lbl_save_continue
                : "Save & Continue"}
            </button>
            <button
              className="btn btn-grey px-4 me-2"
              disabled={
                Object.keys(props.main_obj.prod_overview).length > 0
                  ? false
                  : true
              }
              onClick={() => props.nextStep()}
            >
              {constLabel?.lbl_skip ? constLabel?.lbl_skip : "Skip"}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Tools;
